import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: "Standard",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296895-1TLQSVAHTVXF5EPTJA5H/epbt_abs-doubleshot-keycaps_olivetti.jpg?format=750w",
  },
  {
    _id: uuid(),
    categoryName: "Short",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296885-YJF9K6IA8YJDZA0Q6Y2M/tkc_godspeed75_keyboard_75-percent_1200.jpg?format=300w",
  },
  {
    _id: uuid(),
    categoryName: "Compact",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296888-66OU4S7N2WDSFNMU49D2/Portico_DSA-Magic-Girl_overhead.jpg?format=300whttps://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296888-66OU4S7N2WDSFNMU49D2/Portico_DSA-Magic-Girl_overhead.jpg?format=300w",
  },
  {
    _id: uuid(),
    categoryName: "Custom",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296892-8ABQBYHMJ4BFSYOV0O8W/Infinikey-Graen_minivan_overhead_1920x1080.jpg?format=300w",
  },
  {
    _id: uuid(),
    categoryName: "Split",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    image:
      "https://images.squarespace-cdn.com/content/v1/6116b9604a8e6b639a58a447/1628879296918-JG32PS2HTJR94Z9X1U0P/Infinikey-LedZep_OSA-grey-wood.jpg?format=300w",
  },
];
